function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.9985
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.8364 235.5479c0 3.7773-3.086 6.869-6.87 6.869H7.1113c-3.775 0-6.8614-3.0917-6.8614-6.869V7.1196C.25 3.3428 3.3364.25 7.1113.25h152.855c3.7842 0 6.8701 3.0928 6.8701 6.8696v228.4282h0z",
  strokeWidth: 0.4992,
  transform: "matrix(1 0 0 1.00303 0 -.3672)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.8374 46.39V8.9804H82.811v37.4098h37.0264z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.8433 46.39V8.9804h-37.0059v37.4098h37.0059z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.8433 83.7998V46.3901h-37.0059v37.4097h37.0059z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.8374 83.7998V46.3901H82.811v37.4097h37.0264z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8042 121.2086V83.7998H8.7983v37.4088h37.0059z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.811 121.2086V83.7998H45.8042v37.4088H82.811z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.8374 121.2086V83.7998H82.811v37.4088h37.0264z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.8433 121.2086V83.7998h-37.0059v37.4088h37.0059z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.811 83.7998V46.3901H45.8042v37.4097H82.811z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8042 83.7998V46.3901H8.7983v37.4097h37.0059z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8042 46.39V8.9804H8.7983v37.4098h37.0059z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.811 46.39V8.9804H45.8042v37.4098H82.811z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.811 233.4575v-37.4196H45.8042v37.4196H82.811z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8042 233.4575v-37.4196H8.7983v37.4196h37.0059z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8042 196.038v-37.4098H8.7983v37.4097h37.0059z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.811 196.038v-37.4098H45.8042v37.4097H82.811z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.8433 158.6282v-37.4196h-37.0059v37.4196h37.0059z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.8374 158.6282v-37.4196H82.811v37.4196h37.0264z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.811 158.6282v-37.4196H45.8042v37.4196H82.811z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8042 158.6282v-37.4196H8.7983v37.4196h37.0059z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.8374 196.038v-37.4098H82.811v37.4097h37.0264z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.8433 196.038v-37.4098h-37.0059v37.4097h37.0059z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.8433 233.4575v-37.4196h-37.0059v37.4196h37.0059z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.8374 233.4575v-37.4196H82.811v37.4196h37.0264zM115.2046 8.9803l4.6328 4.662-32.3945 32.7478-4.6319-4.6826 32.3936-32.7272z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.2114 8.9803l4.6319 4.662-32.373 32.7478-4.6329-4.6826 32.374-32.7272",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.4702 46.39l-4.6328 4.6827 32.374 32.7271 4.6319-4.6835-32.373-32.7262z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4429 46.39l-4.6319 4.6827 32.3936 32.7271 4.6328-4.6835L87.4429 46.39",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1729 83.7998l4.6313 4.6714-32.3838 32.7374-4.622-4.6615 32.3745-32.7473z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1992 83.7998l4.6118 4.6714-32.3745 32.7374-4.6323-4.6615 32.395-32.7473",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.2046 83.7998l4.6328 4.6714-32.3945 32.7374-4.6319-4.6615 32.3936-32.7473z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.2114 83.7998l4.6319 4.6714-32.373 32.7374-4.6329-4.6615 32.374-32.7473",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4365 46.39l-4.6323 4.6827 32.395 32.7271 4.6118-4.6835L50.4365 46.39z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4204 46.39l-4.622 4.6827 32.3745 32.7271 4.6313-4.6835L13.4204 46.39",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1729 8.9803l4.6313 4.662-32.3838 32.7478-4.622-4.6826L41.1728 8.9803z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1992 8.9803l4.6118 4.662-32.3745 32.7478-4.6323-4.6826 32.395-32.7272",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4365 233.4575l-4.6323-4.6831 32.395-32.7365 4.6118 4.6821-32.3745 32.7375z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4204 233.4575l-4.622-4.6831 32.3745-32.7365 4.6313 4.6821-32.3838 32.7375",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1729 196.038l4.6313-4.6832-32.3838-32.7266-4.622 4.683 32.3745 32.7267z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1992 196.038l4.6118-4.6832-32.3745-32.7266-4.6323 4.683 32.395 32.7267",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.4702 158.6282l-4.6328-4.6723 32.374-32.7473 4.6319 4.683-32.373 32.7366z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4429 158.6282l-4.6319-4.6723 32.3936-32.7473 4.6328 4.683-32.3945 32.7366",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4365 158.6282l-4.6323-4.6723 32.395-32.7473 4.6118 4.683-32.3745 32.7366z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4204 158.6282l-4.622-4.6723 32.3745-32.7473 4.6313 4.683-32.3838 32.7366",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.2046 196.038l4.6328-4.6832-32.3945-32.7266-4.6319 4.683 32.3936 32.7267z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.2114 196.038l4.6319-4.6832-32.373-32.7266-4.6329 4.683 32.374 32.7267",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.4702 233.4575l-4.6328-4.6831 32.374-32.7365 4.6319 4.6821-32.373 32.7375z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4429 233.4575l-4.6319-4.6831 32.3936-32.7365 4.6328 4.6821-32.3945 32.7375",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4429 8.9803l-4.6319 4.662 32.3936 32.7478 4.6328-4.6826L87.4429 8.9803z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 8.9803L82.811 27.6901l18.5078 18.7 18.5186-18.7-18.5186-18.7098z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.4702 8.9803l-4.6328 4.662 32.374 32.7478 4.6319-4.6826-32.373-32.7272",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 8.9803l-18.4883 18.7098 18.4883 18.7 18.5176-18.7-18.5176-18.7098",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.2114 46.39l4.6319 4.6827-32.373 32.7271-4.6329-4.6835 32.374-32.7262z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 46.39l18.5176 18.7098-18.5176 18.7-18.4883-18.7 18.4883-18.7097z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.2046 46.39l4.6328 4.6827-32.3945 32.7271-4.6319-4.6835L115.2046 46.39",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 46.39l18.5186 18.7098-18.5186 18.7-18.5078-18.7 18.5078-18.7097",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4204 83.7998l-4.622 4.6714 32.3745 32.7374 4.6313-4.6615-32.3838-32.7473z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 83.7998L8.7983 102.5086l18.5186 18.7 18.4873-18.7-18.4873-18.7088z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4365 83.7998l-4.6323 4.6714 32.395 32.7374 4.6118-4.6615-32.3745-32.7473",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 83.7998l-18.519 18.7088 18.519 18.7 18.4878-18.7-18.4878-18.7088",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4429 83.7998l-4.6319 4.6714 32.3936 32.7374 4.6328-4.6615-32.3945-32.7473z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 83.7998L82.811 102.5086l18.5078 18.7 18.5186-18.7-18.5186-18.7088z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.4702 83.7998l-4.6328 4.6714 32.374 32.7374 4.6319-4.6615-32.373-32.7473",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 83.7998l-18.4883 18.7088 18.4883 18.7 18.5176-18.7-18.5176-18.7088",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1992 46.39l4.6118 4.6827-32.3745 32.7271-4.6323-4.6835L78.1992 46.39z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 46.39L82.811 65.0999l-18.4878 18.7-18.519-18.7 18.519-18.7097z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1729 46.39l4.6313 4.6827-32.3838 32.7271-4.622-4.6835L41.1728 46.39",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 46.39l18.4873 18.7098-18.4873 18.7-18.5186-18.7L27.317 46.3901",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4204 8.9803l-4.622 4.662 32.3745 32.7478 4.6313-4.6826L13.4204 8.9803z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 8.9803L8.7983 27.6901l18.5186 18.7 18.4873-18.7L27.3169 8.9803z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4365 8.9803l-4.6323 4.662 32.395 32.7478 4.6118-4.6826L50.4365 8.9803",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 8.9803l-18.519 18.7098 18.519 18.7 18.4878-18.7L64.3232 8.9803",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1992 233.4575l4.6118-4.6831-32.3745-32.7365-4.6323 4.6821 32.395 32.7375z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 233.4575l18.4878-18.7206-18.4878-18.699-18.519 18.699 18.519 18.7206z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1729 233.4575l4.6313-4.6831-32.3838-32.7365-4.622 4.6821 32.3745 32.7375",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 233.4575l18.4873-18.7206-18.4873-18.699-18.5186 18.699 18.5186 18.7206",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 196.038l-18.5186-18.7 18.5186-18.7098 18.4873 18.7097-18.4873 18.7z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4365 196.038l-4.6323-4.6832 32.395-32.7266 4.6118 4.683-32.3745 32.7267",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 196.038l-18.519-18.7 18.519-18.7098 18.4878 18.7097-18.4878 18.7",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.2114 158.6282l4.6319-4.6723-32.373-32.7473-4.6329 4.683 32.374 32.7366z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 158.6282l18.5176-18.7098-18.5176-18.7098-18.4883 18.7098 18.4883 18.7098z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.2046 158.6282l4.6328-4.6723-32.3945-32.7473-4.6319 4.683 32.3936 32.7366",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 158.6282l18.5186-18.7098-18.5186-18.7098-18.5078 18.7098 18.5078 18.7098",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1992 158.6282l4.6118-4.6723-32.3745-32.7473-4.6323 4.683 32.395 32.7366z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 158.6282l18.4878-18.7098-18.4878-18.7098-18.519 18.7098 18.519 18.7098z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1729 158.6282l4.6313-4.6723-32.3838-32.7473-4.622 4.683 32.3745 32.7366",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 158.6282l18.4873-18.7098-18.4873-18.7098-18.5186 18.7098 18.5186 18.7098",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4429 196.038l-4.6319-4.6832 32.3936-32.7266 4.6328 4.683-32.3945 32.7267z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 196.038l-18.5078-18.7 18.5078-18.7098 18.5186 18.7097-18.5186 18.7z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.4702 196.038l-4.6328-4.6832 32.374-32.7266 4.6319 4.683-32.373 32.7267",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 196.038l-18.4883-18.7 18.4883-18.7098 18.5176 18.7097-18.5176 18.7",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.2114 233.4575l4.6319-4.6831-32.373-32.7365-4.6329 4.6821 32.374 32.7375z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 233.4575l18.5176-18.7206-18.5176-18.699-18.4883 18.699 18.4883 18.7206z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.2046 233.4575l4.6328-4.6831-32.3945-32.7365-4.6319 4.6821 32.3936 32.7375",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 233.4575l18.5186-18.7206-18.5186-18.699-18.5078 18.699 18.5078 18.7206M110.5835 37.0249V17.745H92.0649V37.025h18.5186z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.5894 37.0249V17.745h-18.498V37.025h18.498zM101.3188 20.6665L94.3813 27.69l6.9376 6.9933 6.9482-6.9933-6.9483-7.0236",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 20.6665l-6.9278 7.0236 6.9278 6.9933 6.9472-6.9933-6.9472-7.0236M147.5894 74.4445V55.1646h-18.498v19.2799h18.498z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.5835 74.4445V55.1646H92.0649v19.2799h18.5186zM138.3257 58.086l6.9472 7.0138-6.9472 7.0031-6.9278-7.003 6.9278-7.0139",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 58.086l6.9483 7.0138-6.9483 7.0031-6.9375-7.003 6.9376-7.0139M36.5508 111.864V92.574H18.0522v19.2901h18.4986z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.5674 111.864V92.574H55.059v19.2901h18.5083zM27.3169 95.485l-6.9487 7.0236 6.9487 7.0242 6.9175-7.0242-6.9175-7.0236",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 95.485l-6.9482 7.0236 6.9482 7.0242 6.9278-7.0242-6.9278-7.0236M110.5835 111.864V92.574H92.0649v19.2901h18.5186z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.5894 111.864V92.574h-18.498v19.2901h18.498zM101.3188 95.485l-6.9375 7.0236 6.9376 7.0242 6.9482-7.0242-6.9483-7.0236",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 95.485l-6.9278 7.0236 6.9278 7.0242 6.9472-7.0242-6.9472-7.0236M73.5674 74.4445V55.1646H55.059v19.2799h18.5083z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.5508 74.4445V55.1646H18.0522v19.2799h18.4986zM64.3232 58.086l6.9278 7.0138-6.9278 7.0031L57.375 65.1l6.9482-7.0139",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 58.086l6.9175 7.0138-6.9175 7.0031-6.9487-7.003 6.9487-7.0139M36.5508 37.0249V17.745H18.0522V37.025h18.4986z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.5674 37.0249V17.745H55.059V37.025h18.5083zM27.3169 20.6665L20.3682 27.69l6.9487 6.9933 6.9175-6.9933-6.9175-7.0236",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 20.6665L57.375 27.69l6.9482 6.9933L71.251 27.69l-6.9278-7.0236M73.5674 224.6722V205.403H55.059v19.269h18.5083z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.5508 224.6722V205.403H18.0522v19.269h18.4986zM64.3232 221.761l6.9278-7.024-6.9278-7.0027-6.9482 7.0026 6.9482 7.0241",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 221.761l6.9175-7.024-6.9175-7.0027-6.9487 7.0026 6.9487 7.0241",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.5674 187.2732v-19.2897H55.059v19.2897h18.5083z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3232 184.3513l-6.9482-7.0134 6.9482-7.0231 6.9278 7.0231-6.9278 7.0134M147.5894 149.8536v-19.2994h-18.498v19.2994h18.498z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.5835 149.8536v-19.2994H92.0649v19.2994h18.5186zM138.3257 146.9415l6.9472-7.0231-6.9472-7.0232-6.9278 7.0232 6.9278 7.0231",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 146.9415l6.9483-7.0231-6.9483-7.0232-6.9375 7.0232 6.9376 7.0231M73.5674 149.8536v-19.2994H55.059v19.2994h18.5083z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.5508 149.8536v-19.2994H18.0522v19.2994h18.4986zM64.3232 146.9415l6.9278-7.0231-6.9278-7.0232-6.9482 7.0232 6.9482 7.0231",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 146.9415l6.9175-7.0231-6.9175-7.0232-6.9487 7.0232 6.9487 7.0231M110.5835 187.2732v-19.2897H92.0649v19.2897h18.5186z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.5894 187.2732v-19.2897h-18.498v19.2897h18.498zM101.3188 184.3513l-6.9375-7.0134 6.9376-7.0231 6.9482 7.0231-6.9483 7.0134",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.3257 184.3513l-6.9278-7.0134 6.9278-7.0231 6.9472 7.0231-6.9472 7.0134M147.5894 224.6722V205.403h-18.498v19.269h18.498z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.5835 224.6722V205.403H92.0649v19.269h18.5186zM138.3257 221.761l6.9472-7.024-6.9472-7.0027-6.9278 7.0026 6.9278 7.0241",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.3188 221.761l6.9483-7.024-6.9483-7.0027-6.9375 7.0026 6.9376 7.0241",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4204 196.038l-4.622-4.6832 32.3745-32.7266 4.6313 4.683-32.3838 32.7267z",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.5508 187.2732v-19.2897H18.0522v19.2897h18.4986z",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3169 184.3513l-6.9487-7.0134 6.9487-7.0231 6.9175 7.0231-6.9175 7.0134",
  fill: "#d11209",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.232 236.5732H4.4823V4.5728H162.232v232.0004z",
  fill: "none",
  stroke: "#d11209",
  strokeWidth: 2.9955,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  transform: "matrix(1 0 0 1.00303 0 -.3672)"
}));

function SvgCardBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208,
    height: 303,
    viewBox: "0 0 167.0864 242.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card-back.14e1cea8.svg";
export { ForwardRef as ReactComponent };